export class VersionConstant { static readonly APP_VERSION = '1.0.1'; static readonly APP_BUILDVERSION = '2.0.0.181746'; }
